<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="txGroup">
    <th mat-header-cell *matHeaderCellDef> Code </th>
    <td mat-cell *matCellDef="let data">{{data.txGroup ? data.txGroup : ""}}</td>
  </ng-container>

  <ng-container matColumnDef="txGroupDescription">
    <th mat-header-cell *matHeaderCellDef> Omschrijving transactiegroep </th>
    <td mat-cell *matCellDef="let data">{{data.txGroupDescription ? data.txGroupDescription : ""}}</td>
  </ng-container>

  <ng-container matColumnDef="currentRate">
    <th mat-header-cell *matHeaderCellDef> Huidig tarief </th>
    <td mat-cell [ngClass]="{'red': data.currentRate < 0}" *matCellDef="let data">{{getAmount(data.currentRate, 'EUR')}}</td>
  </ng-container>

  <ng-container matColumnDef="minimum">
    <th mat-header-cell *matHeaderCellDef> Ondergrens </th>
    <td mat-cell [ngClass]="{'red': data.minimum < 0}" *matCellDef="let data">{{getAmount(data.minimum, 'EUR')}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
